// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__YhY1D","pulse":"styles_pulse__io3CS","jump":"styles_jump__9nMVW","wiggle":"styles_wiggle__ZTY7l"};